export type WorkspaceManageTagListSkeletonProps = {
  count?: number;
};

export const WorkspaceManageTagListSkeleton = ({
  count = 4,
}: WorkspaceManageTagListSkeletonProps) => {
  return (
    <div className="flex flex-col gap-9 p-2">
      {Array.from(Array(count)).map((_, index) => (
        <div
          className="flex h-6 justify-between gap-3 animate-pulse"
          key={index}
        >
          <div className="bg-ds-natural-50 w-6 rounded-md" />
          <div className="bg-ds-natural-50 grow rounded-md" />
        </div>
      ))}
    </div>
  );
};
